<template>
  <BModal
    title="Novas indicações"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    :hide-header-close="true"
    :centered="true"
    ok-title="Gravar"
    cancel-title="Cancelar"
    v-model="mostrar"
    @ok="gravar"
    @cancel="sair">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true" />
    <BForm
      @submit.prevent="adicionar"
      class="modal__container">
      <InputBasico
        ref="refInputNome"
        type="text"
        label="Nome*"
        name="inputNome"
        class="input__nome"
        v-model="form.nome"
        v-validate="'required|min:3'"
        :errorsBag="errors" />

      <InputCelular
        label="Contato*"
        name="inputContato"
        class="input__contato"
        v-model="form.contato"
        v-validate="'required|minLenTel'"
        :errorsBag="errors" />

      <div class="input__botaoAdicionar">
        <BButton
          type="submit"
          variant="primary">
          Adicionar
        </BButton>
      </div>

      <BTable
        v-if="indicados.length > 0"
        stacked="sm"
        striped
        :items="indicados"
        :fields="camposTabela"
        class="indicacoes">

        <template
          slot="deletar"
          slot-scope="data">
          <BButton
            size="sm"
            @click="removerIndicacao(data.index)"
            variant="danger">
            X
          </BButton>
        </template>
      </BTable>
    </BForm>
  </BModal>
</template>

<script>
import {
  BForm,
  BModal,
  BTable,
  BButton,
} from 'bootstrap-vue/es/components'
import InputBasico from '@/components/inputs/InputBasico.vue'
import InputCelular from '@/components/inputs/pessoais/InputCelular.vue'
import { NECESSARIO_INFORMAR_INDICACOES } from '../../mensagens/painel.msg'

import indicacoesService from '../../../contato/services/indicacoes.service'
import GeradorMensagens from '@/mixins/GeradorMensagens'

export default {
  name: 'PainelIndicacaoModal',
  components: {
    BForm,
    BModal,
    BTable,
    BButton,
    InputBasico,
    InputCelular,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      clienteIndicacao: null,
      barbeiroIndicacao: null,
      resolve: null,
      mostrar: false,
      form: this.valoresIniciaisForm(),
      indicados: [],
      camposTabela: this.retornaCamposMostrarTabela(),
      isLoading: false,
    }
  },
  methods: {
    valoresIniciaisForm() {
      return {
        nome: '',
        contato: '',
      }
    },
    pop(clienteIndicacao, barbeiroIndicacao) {
      this.limpar()
      this.focarPrimeiroCampo()

      this.clienteIndicacao = clienteIndicacao
      this.barbeiroIndicacao = barbeiroIndicacao
      this.mostrar = true

      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    async gravar(event) {
      event.preventDefault()
      if (this.indicados.length > 0) {
        try {
          this.mostrarLoading()

          const dadosGravar = this.retornaDadosGravar()
          const retorno = await indicacoesService.gravar(dadosGravar)
          this.tratarRespostaMsg(retorno)

          this.sair(true)
        } catch (error) {
          this.tratarRespostaMsg(error)
        } finally {
          this.mostrarLoading(false)
        }
      } else {
        this.$awn.warning(NECESSARIO_INFORMAR_INDICACOES)
      }
    },
    retornaDadosGravar() {
      return {
        clienteId: this.clienteIndicacao._id,
        indicacoes: this.indicados,
        barbeiro: this.barbeiroIndicacao.nome,
        filialId: this.barbeiroIndicacao.filial._id,
        filial: this.barbeiroIndicacao.filial.nome,
      }
    },
    sair(resolve = false) {
      this.mostrar = false
      this.resolve(resolve)
    },
    adicionar() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.indicados.push(this.form)
          this.form = this.valoresIniciaisForm()
          this.$validator.reset()
          this.errors.clear()
          this.focarPrimeiroCampo()
        }
      })
    },
    focarPrimeiroCampo() {
      setTimeout(() => {
        this.$refs.refInputNome.focar()
      }, 1)
    },
    retornaCamposMostrarTabela() {
      return [
        { key: 'nome', label: 'Nome' },
        { key: 'contato', label: 'Contato' },
        { key: 'deletar', label: '' },
      ]
    },
    removerIndicacao(indice) {
      this.indicados.splice(indice, 1)
      this.focarPrimeiroCampo()
    },
    mostrarLoading(mostrar = true) {
      this.isLoading = mostrar
    },
    limpar() {
      this.clienteIndicacao = null
      this.barbeiroIndicacao = null
      this.form = this.valoresIniciaisForm()
      this.indicados = []
      this.isLoading = false
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

.modal__container {
  @media (min-width: $medium-size) {
    display: grid;
    grid-column-gap: 0.8em;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: auto;
  }
}

.input {
  &__nome {
    @media (min-width: $medium-size) {
      grid-column: 1 / -1;
    }
  }

  &__contato {
    @media (min-width: $medium-size) {
      grid-column: 1 / 3;
    }
  }

  &__botaoAdicionar {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    @media (min-width: $medium-size) {
      grid-column: 1 / -1;
    }
  }
}

.indicacoes {
  @media (min-width: $medium-size) {
    grid-column: 1 / -1;
  }
}

</style>
